import fetchJSON from '@api/api_helper';
import { Locale } from '@components/common/language_menu/languagesMap';
import { Watermark } from '@components/brandfolder/settings/advanced_tab/watermark/watermarkTypes';

import { ApiDatumResponse } from '@api/v4/ApiResponseTypes';
import { Resource } from '@api/v4/resources/resourceTypes';
import { SearchOperatorOptions } from '@components/show_page/sections/section_search/SearchTypes';

interface UpdateResourceProps {
  key: string;
  defaultSearchOperator?: SearchOperatorOptions.OR | SearchOperatorOptions.AND | SearchOperatorOptions.Quoted;
  defaultStrictSearch?: boolean;
  downloadAlert?: string;
  downloadAlertEnabled?: boolean;
  resourceType?: string;
  ugtLocaleDefault?: Locale;
  watermark?: Watermark;
  watermarkEnabled?: boolean;
  whitelistedLocales?: Locale[];
}

const url = (key: string, resourceTypeString?: string): string => `/api/v4/${resourceTypeString || 'brandfolders'}/${key}`;

export const update = ({
  key,
  resourceType = '',
  ugtLocaleDefault: default_locale = undefined,
  whitelistedLocales: whitelisted_locales = undefined,
  defaultSearchOperator: default_search_operator = undefined,
  defaultStrictSearch: default_strict_search = undefined,
  downloadAlert: download_alert = undefined,
  downloadAlertEnabled: download_alert_enabled = undefined,
  watermark: watermark = undefined,
  watermarkEnabled: watermark_enabled = undefined,
}: UpdateResourceProps): Promise<ApiDatumResponse<Resource>> => (
  fetchJSON(url(key, resourceType && `${resourceType}s`), {
    method: 'PUT',
    body: {
      data: {
        attributes: {
          ...default_locale && { default_locale }, // eslint-disable-line @typescript-eslint/camelcase
          ...whitelisted_locales && { whitelisted_locales }, // eslint-disable-line @typescript-eslint/camelcase
          ...default_search_operator && { default_search_operator }, // eslint-disable-line @typescript-eslint/camelcase
          ...default_strict_search !== undefined && { default_strict_search }, // eslint-disable-line @typescript-eslint/camelcase
          ...download_alert && { download_alert }, // eslint-disable-line @typescript-eslint/camelcase
          ...download_alert_enabled !== undefined && { download_alert_enabled }, // eslint-disable-line @typescript-eslint/camelcase
          ...watermark && { watermark },
          ...watermark_enabled !== undefined && { watermark_enabled }, // eslint-disable-line @typescript-eslint/camelcase
        }
      }
    }
  })
    .then((response) => response)
    .catch(async (response) => { throw (await response.json()); })
);
